import type { DocLocale, TranslationState } from '../types';

export const DOC_LOCALES: DocLocale[] = ['vi', 'en'];

export const localeLabel = (locale: DocLocale) => locale.toUpperCase();

export const otherLocale = (locale: DocLocale): DocLocale => (locale === 'vi' ? 'en' : 'vi');

export const isTranslationActive = (state?: TranslationState) =>
  state === 'pending' || state === 'running';

export const hasActiveTranslations = (
  locales: Partial<Record<DocLocale, { translationState: TranslationState }>>
) => DOC_LOCALES.some((locale) => isTranslationActive(locales[locale]?.translationState));

export const slugify = (value: string) =>
  value
    .toLowerCase()
    .replace(/đ/g, 'd')
    .replace(/Đ/g, 'd')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .replace(/-{2,}/g, '-')
    .slice(0, 80);

export const formatDateTime = (value?: string | null) =>
  value ? new Date(value).toLocaleString() : '-';

export const formatBytes = (bytes?: number | null) => {
  if (!bytes) return '-';
  const units = ['B', 'KB', 'MB', 'GB'];
  let size = bytes;
  let unitIndex = 0;
  while (size >= 1024 && unitIndex < units.length - 1) {
    size /= 1024;
    unitIndex += 1;
  }
  return `${size.toFixed(unitIndex === 0 ? 0 : 1)} ${units[unitIndex]}`;
};

export const formatDuration = (seconds?: number | null) => {
  if (seconds === null || seconds === undefined) return '-';
  const minutes = Math.floor(seconds / 60);
  const rest = Math.floor(seconds % 60);
  return `${minutes}:${rest.toString().padStart(2, '0')}`;
};

export const parseTimecode = (value: string) => {
  const parts = value.split(':').map((part) => Number(part));
  if (parts.length === 1) return Number.isFinite(parts[0]) ? parts[0] : 0;
  if (parts.length === 2 && parts.every(Number.isFinite)) return parts[0] * 60 + parts[1];
  return 0;
};

export const toTimecode = (seconds: number) => {
  const safeSeconds = Math.max(0, Math.floor(seconds));
  const minutes = Math.floor(safeSeconds / 60);
  const rest = safeSeconds % 60;
  return `${minutes}:${rest.toString().padStart(2, '0')}`;
};

export const getErrorMessage = (error: unknown, fallback = 'Request failed.') => {
  if (typeof error === 'object' && error && 'response' in error) {
    const response = (error as { response?: { data?: { message?: string; error?: string } } })
      .response;
    return response?.data?.message || response?.data?.error || fallback;
  }
  return fallback;
};
